module.exports = __webpack_public_path__ + "static/media/rightBlueArrow.09da31b1.svg";